<template>
    <div class="breadcumbcust">
        <div class="titlepart">
            <h4>{{ title }}</h4>
            <b-breadcrumb :items="breadcumbData"/>
        </div>
        <div class="actionpart">
            <slot></slot>
        </div>

    </div>
</template>
<script>
    export default {
        props: {
            breadcumbData: {
                type: Array,
                required: true
            },
            title: {
                type: String,
                required: true
            },
        }
    }
</script>
<style>
    .breadcrumb-item.active {
        color: #38A0E0;
    }
    .breadcumbcust {
        padding-top:1.5rem;
        padding-left:2rem;
        padding-right:2rem;
        position: fixed;
        top:82px;
        left:250px;
        right:0px;
        z-index:7;
        width:auto;
        height:110px;
        background-color:#f5f5f5;
    }
    .breadcumbcust .titlepart{
        display:inline-block;
    }
    .breadcumbcust .actionpart {
        display:inline-block;
        float:right;
    }
</style>
